import React, { useEffect, useState } from 'react'

import './App.css'
import { useNavigate } from 'react-router-dom';
import StanderdConstants from '../../../services/StanderdConstants';
import { AddIconButton, EditIconButton } from '../../../ButtonsIconsInputs/IconButtons';
import AddModal from './AddModal';
import Heading from '../../reusableComp/Heading';
import { InputBox } from '../../../ButtonsIconsInputs/CustomInputs';
import DataTable from './DataTable';
import EditModal from './EditModal';
import DeleteConfirmation from './Deletecomfirmation';
import useUserId from '../../../services/useUserId';



function GroupMenu() {
    const [Data, SetData] = useState([]);
    const [open, setopen] = useState(false);
    const [insertionStatus, setInsertionStatus] = useState(false);
    const [editStatus, setEditStatus] = useState(false);
    const [filteredData, setfilteredData] = useState([]);
    const [editOpen, setEditOpen] = useState(false);
    const [currentDatarow, setcurrentDatarow] = useState(null);
    const api_url = process.env.REACT_APP_API_URL
    const navigate = useNavigate()
    const UserId = useUserId()
    const [query, setQuery] = useState('');


    useEffect(() => {
        if (insertionStatus) {
            getChannels()
            setInsertionStatus(false);
        }
    }, [insertionStatus, Data]);


    const handleopen = () => { setopen(true); }
    const handleclose = () => { setopen(false); }
    const handleEditOpen = (Data, index) => {
        setcurrentDatarow(Data); setEditOpen(true);

    }
    const handleEditClose = () => { setEditOpen(false); setcurrentDatarow(null); }

    const handleDelete = async (item) => {
                let MenuId = item.MenuId

        
        const res = await fetch(`${api_url}/getMenuitems/Delete/?menuId=${MenuId}`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
        });

        if (res.ok) {
            setInsertionStatus(true);
        } else {
                    }
    };







    const AssessmentActions = [
        {
            label: StanderdConstants.EDIT_LABEL,
            handler: handleEditOpen,
            tooltip: StanderdConstants.EDIT_LABEL,
            ButtonComponent: EditIconButton,
        },
        {
            label: StanderdConstants.DELETE_LABEL,
            handler: handleDelete,
            tooltip: StanderdConstants.DELETE_LABEL,
            ButtonComponent: DeleteConfirmation,

        }

    ];




    const getChannels = async () => {
        try {
            const result = await fetch(`${process.env.REACT_APP_API_URL}/getMenuitems/allmenusData`, {
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ userId: UserId })

            });
            const response = await result.json();
            if (result.ok) {
                SetData(response.data)
                setfilteredData(response.data)
            }

        } catch (error) {
                    }
    };

    useEffect(() => {
        getChannels();
    }, []);



    useEffect(() => {
                if (editStatus) {
            getChannels()
            setEditStatus(false)
        }
    }, [editStatus]);



    const handleSearch = (e) => {
                        const searchQuery = e.target.value.toLowerCase();
        setQuery(searchQuery);
        if (!searchQuery) {
            setfilteredData(Data);
        } else {
                        const result = Data.filter(row =>
                Object.values(row) // Get all values from the object (row)
                    .some(value =>
                        value?.toString().toLowerCase().includes(searchQuery.toLowerCase()) // Check if any value contains the search query
                    )
            );
                        setfilteredData(result);
        }
    }

    return (
        <div className="container mx-auto py-8 px-2">
            <Heading heading={"Manage Group Menus"} />
            <div className="flex flex-row  justify-between space-x-2 my-2 ">
                <div className="flex items-center space-x-2">
                    <InputBox
                        inputId='searchChannel'
                        inputLabel="Search Menus"
                        inputValueValue={query}
                        onChange={handleSearch}
                        className="border p-2 rounded-lg"
                        type="text"
                    />

                </div>
                {<div>
                    <AddIconButton action={() => handleopen(true)} id={"GroupMenu"} tooltip='Add new role' />
                    {open && <AddModal handleClose={handleclose} setStatus={setInsertionStatus} />}

                </div>}

            </div>
            <div>
                <div>
                    {/* <DataPreview initialData={filteredData} /> */}
                    <DataTable data={filteredData} actions={AssessmentActions} setStatus={setInsertionStatus} />
                </div>
            </div>





            {editOpen && (
                <EditModal
                    Data={currentDatarow}
                    handleClose={handleEditClose}
                    setStatus={setEditStatus} />

            )}
        </div>

    )

}

export default GroupMenu